import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useSettings } from '../context/SettingsContext';

const fallback = 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?auto=format&fit=crop&w=800&q=80';

export default function ProductCard({ product, index = 0 }) {
  const { settings } = useSettings();
  const cover = product.images?.[0] || product.colors?.[0]?.images?.[0] || fallback;
  const showPrice = settings?.showProductPrice !== false && product.showPrice !== false;
  const showColors = settings?.showProductColors !== false && product.showColors !== false;
  return (
    <motion.div
      style={{ height: '100%' }}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-40px' }}
      transition={{ duration: 0.5, delay: (index % 4) * 0.06 }}
    >
      <Link to={`/products/${product.slug || product._id}`} className="pcard">
        <div className="pcard__media">
          <img src={cover} alt={product.name} loading="lazy" />
          {product.category && <span className="badge pcard__cat">{product.category}</span>}
        </div>
        <div className="pcard__body">
          <h3 className="pcard__name">{product.name}</h3>
          <p className="pcard__desc clamp-2">{product.shortDescription}</p>
          {showColors && product.colors?.length > 0 && (
            <div className="pcard__swatches">
              {product.colors.slice(0, 5).map((c, i) => (
                <span key={i} className="swatch" style={{ background: c.hex }} title={c.name} />
              ))}
            </div>
          )}
          <div className="pcard__foot">
            {showPrice ? (
              <span className="price">
                ₹{Number(product.price).toLocaleString('en-IN')}
                {product.mrp > product.price && <small>₹{Number(product.mrp).toLocaleString('en-IN')}</small>}
              </span>
            ) : <span />}
            <span className="scard__link">View →</span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
